export default {
  enableAmpOnPostType: {
    post: true,
    editorialList: true,
    recipe: true
  }
};